BasePreprocessorFactory.$inject = [];
export default function BasePreprocessorFactory() {
	function BasePreprocessor() {
		Object.defineProperty(this, 'changedHandlers', {
			writable: true,
			enumerable: true,
			value: [],
		});
		return this;
	}

	BasePreprocessor.prototype = {
		addChangedHandler: function (callBack) {
			this.changedHandlers.push(callBack);
		},

		init: function (executor, parameters, dataQueryList) {
			this.executor = executor;
			this.parameters = parameters;
			this.dataQueryList = dataQueryList;
		},

		load: function () {
			return true;
		},

		build: angular.noop,

		callChanged: function () {
			this.changed();
		},

		changed: function () {
			this.changedHandlers.forEach(function (callBack) {
				callBack();
			});
		},

		process: angular.noop,

		clear: angular.noop,
	};

	return BasePreprocessor;
}
